import { render, staticRenderFns } from "./TransactionProject.vue?vue&type=template&id=4f5f0e16&scoped=true"
import script from "./TransactionProject.vue?vue&type=script&lang=js"
export * from "./TransactionProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f0e16",
  null
  
)

export default component.exports